export const Images = {
  logo: require('../images/logo.png'),
  lightLogo: require('../images/light-logo.png'),
  mini_logo: require('../images/mini-logo.png'),
  mini_light_logo: require('../images/mini-light-logo.png'),
  left_top_pattern: require('../images/left-top-pattern.png'),
  right_bottom_pattern: require('../images/right-bottom-pattern.png'),
  icon_logo: require('../images/icon-logo.png'),
  shape_logo: require('../images/shape-logo.png'),
  iran: require('../images/iran.png'),
  IR: require('../images/IR.png'),
  Aras: require('../images/Aras.png'),
  arrowDown: require('../images/arrow-down.png'),
}
